import axiosInstance from "./axios.instance";
import { assignSupportTicket } from "./ticketAssignment.service";
import { getSupportticketApiUrl } from "./supportticketBase";

const withLegacyFallback = async (primaryRequest, legacyRequest) => {
  try {
    return await primaryRequest();
  } catch (error) {
    if (error?.response?.status === 404) {
      return legacyRequest();
    }
    throw error;
  }
};

const API_LIST_TICKETS = async (payload) => {
  try {
    const resp = await withLegacyFallback(
      () => axiosInstance.post(getSupportticketApiUrl("/admin/supportticket"), payload),
      () => axiosInstance.post("/admin/company/supportTicket", payload)
    );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_ASSIGN_TICKET = async (ticketId, assignedTo) => {
  return assignSupportTicket(ticketId, assignedTo);
};

const API_UPDATE_TICKET_STATUS = async (ticketId, status) => {
  try {
    const resp = await withLegacyFallback(
      () =>
        axiosInstance.put(getSupportticketApiUrl(`/admin/supportticket/${ticketId}/status`), {
          status,
        }),
      () => axiosInstance.put(`/admin/company/supportTicket/${ticketId}/status`, { status })
    );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_UPDATE_TICKET_PRIORITY = async (ticketId, priority) => {
  try {
    const resp = await withLegacyFallback(
      () =>
        axiosInstance.put(
          getSupportticketApiUrl(`/admin/supportticket/${ticketId}/priority`),
          { priority }
        ),
      () => axiosInstance.put(`/admin/company/supportTicket/${ticketId}/priority`, { priority })
    );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

const API_TICKET_STATS = async (payload) => {
  try {
    const resp = await withLegacyFallback(
      () => axiosInstance.post(getSupportticketApiUrl("/admin/supportticket/stats"), payload),
      () => axiosInstance.post("/admin/company/supportTicket/stats", payload)
    );
    return resp.data;
  } catch (err) {
    throw err;
  }
};

export {
  API_LIST_TICKETS,
  API_ASSIGN_TICKET,
  API_UPDATE_TICKET_STATUS,
  API_UPDATE_TICKET_PRIORITY,
  API_TICKET_STATS,
};
